import { schema } from "normalizr";
import { Order as OrderRecord } from "records/dashboard/order";

export const Order = new schema.Entity(
    "order",
    {},
    {
        idAttribute: "_id",
    }
);

(Order as any).record = OrderRecord;
